import { FC } from 'react'

import { Box, Flex, Icon, Text, VStack } from '@revolut-internal/ui-kit'

import { DEFAULT_LINE_CHART_HEIGHT } from 'consts/chart'

type LineChartPlaceholderProps = {
  height?: number
}

export const LineChartPlaceholder: FC<LineChartPlaceholderProps> = ({
  height = DEFAULT_LINE_CHART_HEIGHT,
}) => {
  return (
    <Flex height={height} justifyContent="center" alignItems="center">
      <VStack gap="s-4" align="center">
        <Box p="s-2">
          <Icon name="BarChart" color="grey-tone-20" />
        </Box>
        <Text variant="emphasis2" color="grey-tone-20">
          No data to display
        </Text>
      </VStack>
    </Flex>
  )
}
